import {
  AppAvatar,
  AppBorderBox,
  AppBox,
  AppPaper,
  AppPill,
  AppText,
  AppTitle,
} from "../../../../../commons/components";
import IconProhibited from "../../../../../commons/components/icons/prohibited";
import { TeamStatusEnum } from "../../../../../commons/enums/team-status-enum";
import isNullOrUndefined from "../../../../../commons/utilities/null-or-undefined";
import { TournamentTeamStatusEnum } from "../../../../../commons/enums/tournament-team-status-enum";
import IconInvitation from "../../../../../commons/components/icons/invitation";
import { IManageFootballCompetitionInvitedTeam } from "../../../../../commons/models/football/admin/interface/i-manage-football-competition-invited-team";

interface TournamentInvitedTeamCardProps {
  invitedTeam: IManageFootballCompetitionInvitedTeam;
  withBorder?: boolean;
}

export default function TournamentSeasonInvitedTeamCard({
  invitedTeam: competitionTeam,
  withBorder,
}: TournamentInvitedTeamCardProps) {
  const getInvitationColor = (status: string): "success" | "warning" | "danger" => {
    if (status === TournamentTeamStatusEnum.Invited) return "warning";
    if (status === TournamentTeamStatusEnum.Rejected) return "danger";
    return "success";
  };

  const getInvitationMessage = (status: string): string => {
    if (status === TournamentTeamStatusEnum.Invited) return "Invitation: Pending";
    if (status === TournamentTeamStatusEnum.Rejected) return "Invitation: Rejected";
    return "Invitation: Accepted";
  };
  return (
    <AppPaper padding="xs" shadow={withBorder ? "none" : "xs"} withBorder={withBorder}>
      <AppBox displayBlock flexDirection="column" gap="2xs">
        <AppBox justifyContent="space-between" alignItems="center" gap="sm">
          <AppBox gap="xs" alignItems="center">
            {!(
              competitionTeam.status === TournamentTeamStatusEnum.Invited ||
              competitionTeam.status === TournamentTeamStatusEnum.Rejected
            ) && (
              <AppAvatar
                username={competitionTeam.selectedTeam?.name || ""}
                src={competitionTeam.selectedTeam?.logo || ""}
                size="md"
              />
            )}
            {(competitionTeam.status === TournamentTeamStatusEnum.Invited ||
              competitionTeam.status === TournamentTeamStatusEnum.Rejected) && (
              <AppAvatar
                username={competitionTeam.invitedTeam.name}
                src={competitionTeam.invitedTeam?.logo || ""}
                size="md"
              />
            )}

            <AppBox flexDirection="column">
              {!(
                competitionTeam.status === TournamentTeamStatusEnum.Invited ||
                competitionTeam.status === TournamentTeamStatusEnum.Rejected
              ) && <AppTitle as="h6">{competitionTeam.selectedTeam?.shortName}</AppTitle>}
              {(competitionTeam.status === TournamentTeamStatusEnum.Invited ||
                competitionTeam.status === TournamentTeamStatusEnum.Rejected) && (
                <AppTitle as="h6">{competitionTeam.invitedTeam.shortName}</AppTitle>
              )}
            </AppBox>
          </AppBox>
          {!isNullOrUndefined(competitionTeam.invitedTeam) && (
            <AppPill
              icon={<IconInvitation width={15} />}
              label={getInvitationMessage(competitionTeam.status)}
              varient={getInvitationColor(competitionTeam.status)}
              size="md"
            />
          )}
          {(competitionTeam.selectedTeam?.status === Number(TeamStatusEnum.Terminated) ||
            competitionTeam.invitedTeam?.status === Number(TeamStatusEnum.Terminated)) && (
            <AppPill
              icon={<IconProhibited width={18} height={18} color="var(--fg-outline-danger)" />}
              label="Terminated"
              varient="danger"
              size="md"
            />
          )}
        </AppBox>
        {competitionTeam.status === TournamentTeamStatusEnum.Accepted && competitionTeam.invitedTeam && (
          <AppBorderBox border={["Top"]} pt="3xs">
            <AppBox className="w-100">
              <AppText as="label" textAlign="center" className="w-100">
                Invited Team: {competitionTeam.invitedTeam.name}
              </AppText>
            </AppBox>
          </AppBorderBox>
        )}
      </AppBox>
    </AppPaper>
  );
}
